import { IApiExecuteRespone } from './apiInterfaces';

export async function executeApiRequest<T>(
  apiFunc: () => Promise<Response>,
  parseJson: boolean = true
): Promise<IApiExecuteRespone<T>> {
  const response: IApiExecuteRespone<T> = { requestFailed: false };
  try {
    const apiReponse = await apiFunc();
    if (parseJson) {
      response.value = await apiReponse.json();
    }
  } catch (e) {
    response.exception = e;
    response.requestFailed = true;
  }

  return response;
}
